import { FreeShippingTruckSvg } from "components/icons/FreeShippingTruckSvg";
import { CartContext } from "context/cart";
import { LocalizationContext } from "context/localization";
import { useTranslationContext } from "context/translation";
import { FC, useContext } from "react";

type FreeShippingTreshholdProps = {
  freeShippingThreshold: number | null;
  iconClassName?: string;
  subtotal: number;
  textClassName?: string;
};

export const FreeShippingTreshhold: FC<FreeShippingTreshholdProps> = ({
  freeShippingThreshold,
  iconClassName,
  subtotal,
  textClassName,
}) => {
  const { cart } = useContext(CartContext);
  const { formatPriceByLocale } = useContext(LocalizationContext);
  const { freeShipping, amountUntilFreeShipping } = useTranslationContext();
  const { shipping } = cart || {};

  if (!freeShippingThreshold) return null;

  const text =
    shipping === 0 || subtotal > freeShippingThreshold
      ? freeShipping
      : (amountUntilFreeShipping || "").replace(
          "{value}",
          formatPriceByLocale(freeShippingThreshold - subtotal),
        );

  return (
    <div className="flex gap-2 items-center">
      <FreeShippingTruckSvg className={iconClassName} />
      <p className={textClassName}>{text}</p>
    </div>
  );
};
